const Loader = () => {
    return (
        <>
        <div className="timetable-loading active">
            <div className="pageloading-icon">
                <img src="/assets/images/loadingicon.svg" alt="" />
            </div>
        </div>
        </>
    )
}
export default Loader